import Component from 'D:/AUTOMFL/UniApp/uniAdmin/components/uni-stat-table/uni-stat-table.vue'
wx.createComponent(Component)